module.exports = __webpack_public_path__ + "img/crossmark.62618486.svg";